const CLOUD_NAME = "dvjmiukh7";
const API_KEY = "975526872117448";
const API_SECRET = "q4EORSX9VajJ2JR7SxA9altxt1g";

/**
 * Computes SHA-1 hash of string using browser Crypto API
 */
async function computeSha1(str) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  const hashBuffer = await window.crypto.subtle.digest("SHA-1", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

/**
 * Uploads a File or Blob object to Cloudinary with secure signature.
 * Automatically applies Cloudinary transformations (q_auto, f_auto, max width/height)
 * to save bandwidth and storage on free tier while maintaining high visual quality.
 *
 * @param {File|Blob} file - The file to upload
 * @param {"post"|"avatar"} type - Image type for optimal transformation
 * @returns {Promise<{ url: string, rawUrl: string, publicId: string }>}
 */
export async function uploadToCloudinary(file, type = "post") {
  const timestamp = Math.floor(Date.now() / 1000);
  const stringToSign = `timestamp=${timestamp}${API_SECRET}`;
  const signature = await computeSha1(stringToSign);

  const formData = new FormData();
  formData.append("file", file);
  formData.append("api_key", API_KEY);
  formData.append("timestamp", timestamp);
  formData.append("signature", signature);

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`,
    {
      method: "POST",
      body: formData,
    }
  );

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error?.message || "Cloudinary upload failed");
  }

  const data = await response.json();
  const rawUrl = data.secure_url;

  // Insert Cloudinary on-the-fly transformations to shrink file size while preserving high quality
  let transformation = "c_limit,w_800,h_800,q_auto:good,f_auto";
  if (type === "avatar") {
    transformation = "c_fill,g_face,w_200,h_200,q_auto:good,f_auto";
  }

  const optimizedUrl = rawUrl.replace("/upload/", `/upload/${transformation}/`);

  return {
    url: optimizedUrl,
    rawUrl: rawUrl,
    publicId: data.public_id,
  };
}
